var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirmation" }, [
    _c("div", { staticClass: "professional" }, [
      _c("span", { staticClass: "header" }, [
        _vm._v("Limpeza com o(a) Profissional")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "professional-info" }, [
        _c("img", {
          staticClass: "profile-picture",
          attrs: { src: _vm._f("profilePicture")(_vm.professional) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "infos" }, [
          _c("div", { staticClass: "name" }, [
            _c("span", [
              _vm._v(_vm._s(_vm._f("shorterFullName")(_vm.professional)))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rating" },
              [
                _c("Star"),
                _vm._v(" "),
                _c("span", { staticClass: "rating-number" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm._f("rating")(_vm.professional)) +
                      " "
                  ),
                  _vm.professional.total_feedbacks_count > 3
                    ? _c("span", { staticClass: "feedback-count" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm._f("feedbacks")(_vm.professional)) +
                            ")"
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "orders-count" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.totalOrders() > 0
                    ? _vm.totalOrders() + " limpezas  realizadas"
                    : "Novo(a) profissional"
                ) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "order-infos" }, [
      _c("span", { staticClass: "header" }, [
        _vm._v("Detalhes do agendamento")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "when" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("span", [
            _c("b", [
              _vm._v(
                "Dia " +
                  _vm._s(_vm._f("formatDate")(_vm.date, "DD/MM/YYYY")) +
                  " (" +
                  _vm._s(_vm._f("weekday")(_vm.date)) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n          Iniciando às "),
            _c("b", [_vm._v(_vm._s(_vm.initialHour) + "h")]),
            _vm._v(" com uma duração de "),
            _c("b", [_vm._v(_vm._s(_vm.duration) + "h.")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", [
            _vm._v("\n          No endereço "),
            _c("b", [_vm._v(_vm._s(_vm._f("name")(_vm.address)))])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm._f("streetAddress")(_vm.address)))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.description || "Nenhuma descrição da limpeza informada!"
              )
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.pricingWithDiscount
      ? _c("div", { staticClass: "total" }, [
          _c("div", [
            _c("span", { staticClass: "subtotal-text" }, [_vm._v("Subtotal")]),
            _vm._v(" "),
            _c("span", { staticClass: "subtotal-pricing" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.pricing)))
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "text" }, [
              _vm._v("Total (com desconto)")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "pricing" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.pricingWithDiscount)))
            ])
          ])
        ])
      : _c("div", { staticClass: "total" }, [
          _c("div", [
            _c("span", { staticClass: "text" }, [_vm._v("Total")]),
            _vm._v(" "),
            _c("span", { staticClass: "pricing" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.pricing)))
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-485a8b49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485a8b49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Confirmation/OrderReview.vue
// module id = null
// module chunks = 